
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ComponentIntroduceCard extends Vue {
  @Prop({ default: "" }) text!: string;
}
